import React from 'react';
import './Astrologydetail.scss';
import  Globals from '../../api' ;
import Rightbar from "../../components/Rightbar/Rightbar";
import ROS_Middle_Center_728_90 from '../ad-units/ros_middle_center_728_90';
import ROS_Top_Center_728_90 from '../ad-units/Ros_top_center_728_90';

export default class AstrologyDetail extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            AstroData  : [],
            FaladeshPages : [],
            HoroscopeTerm : [],
            Terms : [],
            meta : [] ,
            title : [],
            meta_keywords : [],
            meta_description : [],
            HoroscopeNavigationItems : [],
            HoroscopeDescription : [],
            HoroscopeNavigation : [],
            RashiSlider : [],
            Rightbar : [],
            AdData :[] 
           
         };
      }
      getAds(){
        const url= Globals.AdConfig;
                fetch(url)
                .then((res) => res.json())
                .then((data) => {
                  
                    this.setState({
                      AdData : data.AdContents[0].ROS
                    })
                    
                }) 
                
      }  
      getRightbar(){
        const url= Globals.Rightbar_api+"/astrology-articles-in-kannada";
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
            
            this.setState({
              Rightbar : data.Contents[0]
            })
        })   
      }    
    componentDidMount() {
        let URI = window.location.pathname  + window.location.search;
        console.log(URI);
           const url= Globals.language_based_api+URI;
           fetch(url)
           .then((res) => res.json())
           .then((data) => {
             
               this.setState({
                AstroData : data.Contents[2],
                FaladeshPages : data.Contents[2].FaladeshPages,
                HoroscopeNavigationItems : data.Contents[2].HoroscopeNavigation,
                HoroscopeNavigation : data.Contents[2].HoroscopeNavigation.Selected ,
                RashiSlider :  data.Contents[2],
                Terms : data.Contents[2].Terms,
                HoroscopeTerm : data.Contents[2].Term,
                 meta : data.Meta ,
                 title : data.Title,
                 meta_keywords : data.Meta.keywords.Attributes.content,
                 meta_description : data.Meta.description.Attributes.content
               })
           }) 
           this.getRightbar();
           this.getAds();
         }
         handleChange (e) {
            //console.log(e.target.value);
            window.location = e.target.value;
            
          }
          
    render() {
   
        let url = new URL(window.location);
        let searchParams = new URLSearchParams(url.search);
        let UrlRashiID = searchParams.get('rashiID');
        let Urldate = searchParams.get('date'); 

        let HoroscopeNavigation = this.state.HoroscopeNavigation;
        let HoroscopeNavigationItems  = this.state.HoroscopeNavigationItems;
        let DailyTitle = HoroscopeNavigationItems.DailyTitle;
        let WeeklyTitle = HoroscopeNavigationItems.WeeklyTitle;
        let MonthlyTitle = HoroscopeNavigationItems.MonthlyTitle;
        let YearlyTitle = HoroscopeNavigationItems.YearlyTitle;
        let AstroData = this.state.AstroData;
        let RashiSliderItems = this.state.RashiSlider;
        let HoroscopeTerms = this.state.Terms;
        let SelectedTerm = this.state.HoroscopeTerm;
        //let Selected = SelectedTerm.Value;
        // const RashiTermsBar =   RashiSliderItems.map((item,i)=>{ 
        //     return(
        //     <IntlProvider locale="en" messages="option values"> 
        //   <FormattedMessage id={item.Name}  key={item.EnglishName + '-' + i}>
        //     {(message) => <option value={"/astrology-weekly-horoscope-details?rashiID="+item.RashiID} selected={UrlRashiID == item.RashiID} >{message}</option>}
        //   </FormattedMessage>
        //   </IntlProvider>
        //     )});
        //console.log("rashies", RashiSliderItems.Rashies);
        // const RashiTermsBar =   RashiSliderItems.map((item,i)=>{ 
        //     return(
        //      <option value={"/astrology-weekly-horoscope-details?rashiID="+item.RashiID} selected={UrlRashiID == item.RashiID} >{item.Name}</option>
          
        //     )});
            // const HoroscopeTermsBar =   HoroscopeTerms.map((item,i)=>{  
            //     return(
            //     <IntlProvider locale="en" messages="option values"> 
            //   <FormattedMessage id={item.Title}  key={item.Title + '-' + i}>
            //     {(message) => <option value={item.Url} selected={Urldate == item.Value}>{message}</option>}
            //   </FormattedMessage>
            //   </IntlProvider>
            //     )});

            const HoroscopeTermsBar =   HoroscopeTerms.map((item,i)=>{  
                return(   
             <option value={item.Url} selected={Urldate == item.Value}>{item.Title}</option>
                )});
        return (
            
            <div className="astrology_page">
                <div className="full_ads_block"  >
                 <ROS_Top_Center_728_90 AdData= {this.state.AdData} />
                 </div>
                <div className="container padding15">
                
                    <div className="row">
                        
                        <div className="col">
                            {/* <ul className="wdbreadcrumb ">
                                <li><a href="#">धर्म-संसार</a></li>
                                <li><a href="#">ज्योतिष</a></li>
                                <li>साप्ताहिक--राशिफल विस्तार</li>
                            </ul> */}
                            <div className="astrology_container m-t-10">

                            <ul className="astro_buttons">
                                    <li className = {(HoroscopeNavigation == "Daily") ? 'daily_rashi active' : 'daily_rashi' }><a href="/astrology-daily-horoscope">{DailyTitle}</a></li>
                                    <li  className = {(HoroscopeNavigation == "Weekly") ? 'week_rashi active' : 'week_rashi' }><a href="/astrology-weekly-horoscope">{WeeklyTitle}</a></li>
                                    <li  className = {(HoroscopeNavigation == "Monthly") ? 'month_rashi active' : 'month_rashi' }><a href="/astrology-monthly-horoscope">{MonthlyTitle}</a></li>
                                    <li  className = {(HoroscopeNavigation == "Yearly") ? 'year_rashi active' : 'year_rashi' }><a href="/astrology-yearly-horoscope">{YearlyTitle}</a></li>
                                </ul>
                                <div className="astro_head">
                                <div className="astro_select_date">
                                        
                                        {/* <select onChange={this.handleChange}>
                                           {RashiTermsBar}
                                        </select> */}

                                        <select onChange={this.handleChange}>
                                           {HoroscopeTermsBar}
                                        </select>
                                    </div>
                                    </div>
                                <div className="astrology_detail_sect">
                                    <div className="ast_d_head">
                                        <span className="ast_d_icon"><img src={"https://hindi.webdunia.com/img/new-zodiac-signs/zdc"+AstroData.RashiID+".png"}/></span>
                                        <h4>{AstroData.RashiName} {AstroData.FaladeshTitle}</h4>
                                    </div>
                                    <div className="ast_d_content">
                                        <p>{AstroData.Horoscope}</p>
                                    </div>
                                </div>
                            </div>
                            <br/>
                            <div className="ads_block m-t-15"  >
                            <ROS_Middle_Center_728_90 AdData= {this.state.AdData} />
                            </div>
                        </div>
                        <div className="col right_side_bar">
                        <Rightbar Rightbar = {this.state.Rightbar} googleAds ={this.state.AdData} />
                            
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}